import GradingList from "@/controllers/grading/grading-list.js";
import axios from "axios";
import store from '@/store';

export default {
  extends: GradingList,

  data() {
    return {
      term_id: 0,
    };
  },

  methods: {
    ...GradingList.methods,
    getAcademicYearIdByTerm(termId) {
      const selectedTerm = this.academicYearArr?.find(
        term => String(term.id) === String(termId)
      );

      return selectedTerm?.academic_year_id || 0;
    },

    getAcademicYear() {
      axios.get('period/term/options')
        .then(res => {
          const defaultOption = [{
            id: 0,
            text: 'Select Academic Term'
          }];
          this.academicYearArr = defaultOption.concat(res.data.terms || []);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);

      if (fieldName === "term_id") {
        this.subject_id = 0;
        this.student_id = 0;
        this.selectedClass = 0;
        this.class_id = 0;
        this.classArr = [];
        this.subjectArr = [];
        this.studentNameArr = [];
        this.examArr = [];
        this.exam_id = 0;
        this.academic_year = this.getAcademicYearIdByTerm(val);

        if (this.academic_year) {
          this.getClass(this.academic_year);
        }
      }

      if (fieldName == "class_id") {
        this.subjectArr = [];
        this.studentNameArr = [];
        this.subject_id = 0;
        this.student_id = 0;
        this.exam_id = 0;
        this.examArr = [];
        this.getStudentName(val);
        this.getSubjectByClassId(val);
        this.getExams(val);
      }
    },

    getClass(academic_year) {
      axios.get(`class/classListByAcdYearId/${academic_year}`)
          .then(res => {
              let $defaultSelectOption = [{
                  'id': 0,
                  'text': 'Select Class',
                  'subjects': [],
              }];
              this.classArr = $defaultSelectOption.concat(res.data);
              this.isLoading = false;
          }).catch((error) => {
              if (error.response.status == 401) {
                  this.$store.commit('logout');
                  window.location.replace('login');
              }
              this.isLoading = false;
          });
    },

    getExams($classId) {
      axios.get("/exam/examList", {
        params: {
          class_id: $classId,
          term_id: this.term_id,
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Exam'
          }];
          this.examArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          console.error("Exam API Error", error);
        });
    },

    selectEvent({ id }, fieldName) {
      const value = id == 'Select' ? '' : id;
      this.$set(this, fieldName, value);

      if (fieldName === 'term_id') {
        this.academic_year = this.getAcademicYearIdByTerm(value);
      }
    },

    reset() {
      this.isInitialState = true;
      this.gradingList = {};
      this.selectedYear = 0;
      this.academic_year = 0;
      this.term_id = 0;
      this.selectedClass = 0;
      this.class_id = 0;
      this.student_id = 0;
      this.subject_id = 0;
      this.exam_id = 0;
      this.classArr = [];
      this.studentNameArr = [];
      this.subjectArr = [];
      this.examArr = [];
      this.isSearched = false;
      this.search_status = false;
      this.isLoading = false;
    },

    searchGrading(page = 1) {
      if (!this.exam_id || this.exam_id == 0) {
        this.$notification.error("Please select an exam before searching.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      this.isLoading = true;
      this.isInitialState = false;
      this.searchBtnStatus = true;
      var request = {
        params: {
          academic_year: this.academic_year,
          term_id: this.term_id,
          class_id: this.class_id,
          student_id: this.student_id,
          subject_id: this.subject_id,
          exam_id: this.exam_id,
          campus_id: store.state.user.campus_id
        },
      };
      this.searchedData = {
        ...request.params,
        search_status: this.searchBtnStatus
      };
      this.isSearched = true;
      axios
        .get("/grading/search?page=" + page, request)
        .then((response) => {
          this.search_status = true;
          this.gradingList = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Grading Search API Error", error);
        });
    },

    showDetail(student_id, exam_id, class_id) {
      this.$router.push({
        name: "gradingDetail",
        params: {
          student_id: student_id,
          exam_id: exam_id
        },
        query: {
          class_id: class_id
        }
      });
    },

    showEdit(student_id, exam_id, class_id) {
      this.$router.push({
        name: "gradingEdit",
        params: {
          student_id: student_id,
          exam_id: exam_id
        },
        query: {
          class_id: class_id
        }
      });
    },
  }
};
